import _ from "underscore";
import $ from "jquery";
import Backbone from "backbone";

export default Backbone.View.extend({

        // initialize
        initialize: function () {
          this.onScroll = this.onScroll.bind(this);
          this.getSizes = this.getSizes.bind(this);

            var headerHeight = $(".js-Header").eq(0).height();
            var $sticky = $(".js-PubliStickyNav");
            if ($sticky.length) {
                headerHeight += $sticky.eq(0).height();
            }

            this.headerHeight = headerHeight;

            var $el = this.$el;
            var speed = $el.data("parallax-speed") || 0.6;
            var perspective = $el.data("parallax-perspective") || 1;

            this.speed = speed;
            this.perspective = perspective;

            this.getSizes();

            $(window)
                .on("scroll.PubliParallax", this.onScroll)
                .on("resize.PubliParallax", this.getSizes);

        },

        //getSizes
        getSizes: function () {
            var $el = this.$el;
            var elPos = Math.floor($el.offset().top);
            var elHeight = $el.height();
            var perspective = this.perspective;
            var headerHeight = this.headerHeight;
            var parallaxHeight = perspective != 1 ? Math.ceil(elHeight * perspective) : elHeight;
            var startPos = elPos - ((parallaxHeight - elHeight) / 2) - headerHeight;
            $el.css("background-position", "");
            var cssBgPos = $el.css("background-position").split(" ");
            this.cssBgPos = {
                x: parseInt(cssBgPos[0], 10),
                y: parseInt(cssBgPos[1], 10),
            }

            this.startPos = startPos;
            this.elHeight = elHeight;
            this.onScroll();

        },


        //onScroll
        onScroll: function () {
            var yPos = window.pageYOffset;

            var topLimit = this.startPos;
            var newPos = (yPos >= topLimit) ? this.cssBgPos.y + ((yPos - topLimit) * this.speed) : this.cssBgPos.y;
            var coords = this.cssBgPos.x + "% " + newPos + "px";
            this.render(coords);
        },

        // render
        render: function (coords) {
            this.$el.css({
                "background-position": coords
            });
        }

    });
